import { useAPI } from "@/services/api";
import { useScaffold } from "@Light/scaffold";
import { useSearchParams } from "@Light/utils/context";
import { useEffect, useRef } from "react";

export type LoginProps = {};

export const Login: React.FC<LoginProps> = ({}) => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? "";
  const { useLoginMutation } = useAPI();
  const [login, loginState] = useLoginMutation();
  const scaffold = useScaffold();
  const submittedTokenRef = useRef<string | null>(null);

  // Submit login on mount, prevent double submission of the same token.
  useEffect(() => {
    if (!token || token === submittedTokenRef.current) {
      return;
    }

    submittedTokenRef.current = token;
    login({ token });
  }, [login, token]);

  const Navigate = scaffold.system.navigate;
  if (!token || loginState.isError || loginState.isSuccess) {
    // Preserve query parameters (except token) when redirecting after login
    const params = new URLSearchParams(searchParams);
    params.delete("token");
    const queryString = params.toString();
    const redirectPath = queryString ? `/?${queryString}` : "/";
    return <Navigate to={redirectPath} />;
  }

  return null;
};
